"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeSortingOptions = makeSortingOptions;

/**
 * Creates dataserver standard sort options object
 * @param sortBy - An array of sort option objects, for example [{ by: 'DisplayOrder', order: 'Ascending' }]
 * @returns {*}
 */
function makeSortingOptions(sortBy) {
  if (sortBy) {
    return {
      Sort: sortBy.map(function (sort) {
        return {
          $: {
            By: sort.by,
            Order: sort.order || 'Ascending'
          }
        };
      })
    };
  }

  return {};
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/gfrl/utils/sorting-options.js
// module id = 247
// module chunks = 0